import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLogin } from "react-admin";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

export default function NetworkLogin() {
  const login = useLogin();
  const [networks, setNetworks] = useState<{ id: string; value: string }[]>([]);
  const [network, setNetwork] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/business-networks`)
      .then((response) => setNetworks(response.data))
      .catch(() => setError("Netværk kunne ikke indlæses. Prøv igen senere."));
  }, []);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setPending(true);
    setError("");
    try {
      await login({
        username,
        password,
        business_network: network === "system" ? undefined : network,
        system_admin: network === "system",
      });
    } catch {
      setError(
        network === "system"
          ? "Login mislykkedes. Kontrollér e-mail og adgangskode."
          : "Login mislykkedes. Kontrollér e-mail og adgangskode, eller prøv at vælge et andet netværk.",
      );
    } finally {
      setPending(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        bgcolor: "#f2f6f3",
        p: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 440, borderRadius: 3 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" component="h1" gutterBottom>
            Administration
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Log ind på dit erhvervsnetværk.
          </Typography>
          <Stack component="form" spacing={2} onSubmit={submit}>
            {error && <Alert severity="error">{error}</Alert>}
            <TextField
              select
              required
              label="Netværk"
              value={network}
              onChange={(e) => setNetwork(e.target.value)}
              disabled={pending}
            >
              {networks.map((item) => (
                <MenuItem key={item.id} value={item.value}>
                  {item.value}
                </MenuItem>
              ))}
              <MenuItem value="system">Systemadministrator</MenuItem>
            </TextField>
            <TextField
              required
              label="E-mail"
              type="email"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={pending}
            />
            <TextField
              required
              label="Adgangskode"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={pending}
            />
            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={pending || !network}
            >
              {pending ? "Logger ind…" : "Log ind"}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
